import { fetchListingPageData } from './ducks/network';
import { setCurrentPaginatorPage } from './ducks/listingPagePagination';
import { setFiltersSetup } from './ducks/listingPageFilters';
import { setHeaderBanner } from './ducks/listingPageBanners';
import { setLocationSearchEnabled } from './ducks/listingPageSetup';

export const LISTING_PAGE_FILTERS = 'LISTING_PAGE_FILTERS';

function initOnPopStateHandler() {
  window.onpopstate = function onPopState(event) {
    const state = event.state;
    if (!state) {
      return;
    }

    switch (state.type) {
      case LISTING_PAGE_FILTERS:
        window.appState.dispatch(setCurrentPaginatorPage(state.payload.pageNumber));
        window.appState.dispatch(setFiltersSetup(state.payload.filters));
        window.appState.dispatch(setHeaderBanner(state.payload.banner));
        window.appState.dispatch(setLocationSearchEnabled(
          Boolean(state.stockChecker && state.stockChecker.isLocationSearchEnabled)
        ));
        window.appState.dispatch(
          fetchListingPageData(/* whatChanged = */ 'filters', /* updateBrowserHistory = */ false)
        );
        break;
      default:
        break;
    }
  };
}

function pushState(state, title = '', URL = null) {
  return window.history.pushState(state, title, URL);
}

function replaceState(state, title = '', URL = null) {
  return window.history.replaceState(state, title, URL);
}

export default {
  pushState: pushState,
  replaceState: replaceState,
  initOnPopStateHandler: initOnPopStateHandler,
  actionTypes: {
    LISTING_PAGE_FILTERS
  }
};
